<template>
  <b-container>
    <h3>{{ getContentItem("ordersButton") }}</h3>
    <b-table
      class="blue"
      stacked="md"
      hover
      striped
      show-empty
      :items="orders"
      :fields="OrderResultsColumns"
      :no-provider-filtering="true"
      :no-provider-sorting="true"
      :no-provider-paging="true"
    >
      <template slot="OrderNumber" slot-scope="row">
        <router-link
          :to="{ name: 'OrderDetails', query: { orderNumber: row.item.OrderNumber, orderSource: row.item.OrderSource, dealerCode: row.item.DealerCode, salesOrg: row.item.SalesOrganization }}"
        >
          {{ row.item.OrderNumber }}
        </router-link>
      </template>
      <template slot="SubTotal" slot-scope="row">
        <currency-text v-if="!hasPermission('HideInvoicePricing')" :amount="row.item.SubTotal" :currency-code="row.item.CurrencyCode" />
      </template>
      <template slot="empty">
        <div v-if="isOrdersLoading" class="d-flex justify-content-center">
          <loading-spinner />
        </div>
      </template>
    </b-table>
  </b-container>
</template>

<script>
  import { mapGetters } from "vuex"

  import { ErrorLogService } from "@/services/ErrorLogService"
  import { InvoiceService } from "@/services/InvoiceService"
  import { OrderService } from "@/services/OrderService"
  import { BackorderService } from "@/services/BackorderService"

  import { stringHelper } from "@/components/mixins/stringHelper"
  import { formatDateTime } from "@/components/mixins/formatDateTime"

  import CurrencyText from "@/components/Elements/CurrencyText"
  import LoadingSpinner from "@/components/Elements/LoadingSpinner"

  import OrdersMenu from "@/components/SubMenus/OrdersMenu"
  import OrdersSearchWidgetForm from "@/components/SubMenus/OrdersSearchWidgetForm"

  export default {
    components: {
      CurrencyText,
      LoadingSpinner
    },
    mixins: [stringHelper, formatDateTime],
    props: {
      documentNumber: {
        type: String,
        default: "",
      },
      partNumber: {
        type: String,
        default: "",
      },
      dealerCodes: {
        type: Array,
        default: () => []
      },
    },
    data: () => ({
      OrderResultsColumns: [
        { key: "OrderNumber", localizationKey: "orderNumber" },
        { key: "SalesOrganization", localizationKey: "salesOrg" },
        { key: "DealerPurchaseOrder", localizationKey: "poNumber" },
        { key: "OrderDate", localizationKey: "date", formatter: "formatDateTime" },
        { key: "OrderStatus", localizationKey: "status" },
        { key: "ShipmentType", localizationKey: "orderType" },
        { key: "SubTotal", localizationKey: "total" },
      ],
      isOrdersLoading: true,
      orders: []
    }),
    computed: {
      ...mapGetters(["getContentItem", "activeAccountId", "user", "hasPermission"]),
      SearchKeyword() {
        return this.documentNumber ? this.documentNumber : this.partNumber
      },
    },
    mounted() {
      this.OrderSearch();
      this.OrderResultsColumns = this.OrderResultsColumns.map(column => {
        if (typeof column === "object") {
          return Object.assign({}, column, { label: this.getContentItem(column.localizationKey) })
        }
        return column
      })
    },
    methods: {
      OrderSearch() {
        var dealerCodesToSearch = JSON.parse(JSON.stringify( this.dealerCodes ));
        
        // clear out any existing orders because we will be concatenating results if there are more than 100 dealers
        this.orders = [];
        while(dealerCodesToSearch.length) {
          this.isOrdersLoading = true
          var dealersToSearchUpTo100 = dealerCodesToSearch.splice(0,100);

          OrderService.SearchOrdersByDocumentOrPart(
            this.activeAccountId,
            this.user.UserId,
            this.partNumber,
            this.documentNumber,
            dealersToSearchUpTo100
          )
            .then(response => {
              this.orders = this.orders.concat(response.data);
            })
            .catch(err => {
              ErrorLogService.LogException(err)
              return []
            })
            .then(() => {
              this.isOrdersLoading = false
            })
        }
     }

    }
  }
</script>
